// The display preferences every formatter reads: date format, currency and
// rows per page. They come from ChurchConfig, but formatDate() and friends are
// plain functions called from ~20 modules with no access to a hook, so the
// values are held here and refreshed by useChurchConfig whenever the
// configuration loads or is saved.

import type { ChurchConfig } from '../types';
import { DEFAULT_CURRENCY, DEFAULT_DATE_FORMAT } from './churchSettings';
import type { DateFormat } from './churchSettings';

export interface DisplayPreferences {
  dateFormat: DateFormat;
  currencyCode: string;
  pageSize: number;
}

const DEFAULTS: DisplayPreferences = {
  dateFormat: DEFAULT_DATE_FORMAT,
  currencyCode: DEFAULT_CURRENCY,
  pageSize: 10
};

let current: DisplayPreferences = DEFAULTS;

export const getPreferences = (): DisplayPreferences => current;

/** Takes the formats from a loaded configuration; blanks keep the defaults. */
export const applyPreferences = (config?: ChurchConfig | null): void => {
  const pageSize = Number(config?.defaultPageSize);
  current = {
    dateFormat: (config?.dateFormat as DateFormat) || DEFAULTS.dateFormat,
    currencyCode: String(config?.currencyCode || '').trim().toUpperCase() || DEFAULTS.currencyCode,
    pageSize: Number.isFinite(pageSize) && pageSize > 0 ? pageSize : DEFAULTS.pageSize
  };
};

/** Back to the built-in defaults — for tests. */
export const resetPreferences = (): void => { current = DEFAULTS; };
